// AUTO-GENERATED by tools/design-tokens/generate-css-refs.ts -- do not edit.
// Regenerate: npm run generate:derived-artifacts (or any typecheck/vitest run -- both ensure it)

import {
	statusColors,
	gradientColors,
	opacityColors,
	overlayColors,
} from "./css-refs.colors.extended.ts";

/** Color tokens */
export const colors = {
	brand: {
		primary: "var(--color-brand-primary)",
		primaryLight: "var(--color-brand-primary-light)",
		primaryForeground: "var(--color-brand-primary-foreground)",
		contrast: "var(--color-brand-contrast)",
		secondary: "var(--color-brand-secondary)",
		secondaryForeground: "var(--color-brand-secondary-foreground)",
		tertiary: "var(--color-brand-tertiary)",
		alternate: "var(--color-brand-alternate)",
		navy: "var(--color-brand-navy)",
	},
	primary: {
		DEFAULT: "var(--color-primary-default)",
		foreground: "var(--color-primary-foreground)",
		lighter: "var(--color-primary-lighter)",
		light: "var(--color-primary-light)",
		softer: "var(--color-primary-softer)",
		medium: "var(--color-primary-medium)",
		dark: "var(--color-primary-dark)",
	},
	secondary: {
		DEFAULT: "var(--color-secondary-default)",
		foreground: "var(--color-secondary-foreground)",
		dark: "var(--color-secondary-dark)",
	},
	accent: {
		DEFAULT: "var(--color-accent-default)",
		foreground: "var(--color-accent-foreground)",
	},
	muted: {
		DEFAULT: "var(--color-muted-default)",
		foreground: "var(--color-muted-foreground)",
	},
	semantic: {
		success: "var(--color-semantic-success)",
		successForeground: "var(--color-semantic-success-foreground)",
		successBackground: "var(--color-semantic-success-background)",
		successTint: "var(--color-semantic-success-tint)",
		warning: "var(--color-semantic-warning)",
		warningForeground: "var(--color-semantic-warning-foreground)",
		warningBackground: "var(--color-semantic-warning-background)",
		warningTint: "var(--color-semantic-warning-tint)",
		error: "var(--color-semantic-error)",
		errorForeground: "var(--color-semantic-error-foreground)",
		errorBackground: "var(--color-semantic-error-background)",
		errorTint: "var(--color-semantic-error-tint)",
		info: "var(--color-semantic-info)",
		infoForeground: "var(--color-semantic-info-foreground)",
		infoBackground: "var(--color-semantic-info-background)",
		infoTint: "var(--color-semantic-info-tint)",
	},
	success: "var(--color-success)",
	warning: {
		DEFAULT: "var(--color-warning-default)",
		foreground: "var(--color-warning-foreground)",
	},
	error: {
		DEFAULT: "var(--color-error-default)",
		foreground: "var(--color-error-foreground)",
	},
	info: "var(--color-info)",
	text: {
		primary: "var(--color-text-primary)",
		secondary: "var(--color-text-secondary)",
		tertiary: "var(--color-text-tertiary)",
		disabled: "var(--color-text-disabled)",
		inverse: "var(--color-text-inverse)",
	},
	background: {
		primary: "var(--color-background-primary)",
		secondary: "var(--color-background-secondary)",
		tertiary: "var(--color-background-tertiary)",
		coolNeutral: "var(--color-background-cool-neutral)",
		muted: "var(--color-background-muted)",
	},
	foreground: "var(--color-foreground)",
	border: {
		"default": "var(--color-border-default)",
		muted: "var(--color-border-muted)",
		warning: "var(--color-border-warning)",
		error: "var(--color-border-error)",
		primary: "var(--color-border-primary)",
		strong: "var(--color-border-strong)",
	},
	accents: {
		accent1: "var(--color-accents-accent1)",
		accent2: "var(--color-accents-accent2)",
		accent3: "var(--color-accents-accent3)",
		accent4: "var(--color-accents-accent4)",
	},
	gray: {
		"50": "var(--color-gray-50)",
		"100": "var(--color-gray-100)",
		"200": "var(--color-gray-200)",
		"300": "var(--color-gray-300)",
		"400": "var(--color-gray-400)",
		"500": "var(--color-gray-500)",
		"600": "var(--color-gray-600)",
		"700": "var(--color-gray-700)",
		"800": "var(--color-gray-800)",
		"900": "var(--color-gray-900)",
		line: "var(--color-gray-line)",
		dark: "var(--color-gray-dark)",
		darker: "var(--color-gray-darker)",
		darkest: "var(--color-gray-darkest)",
	},
	white: "var(--color-white)",
	black: "var(--color-black)",
	green: {
		"50": "var(--color-green-50)",
		"100": "var(--color-green-100)",
		"200": "var(--color-green-200)",
		"300": "var(--color-green-300)",
		"400": "var(--color-green-400)",
		"500": "var(--color-green-500)",
		"600": "var(--color-green-600)",
		"700": "var(--color-green-700)",
		"800": "var(--color-green-800)",
		"900": "var(--color-green-900)",
		DEFAULT: "var(--color-green-default)",
		dark: "var(--color-green-dark)",
		light: "var(--color-green-light)",
		lighter: "var(--color-green-lighter)",
		auctionWash: "var(--color-green-auction-wash)",
		softer: "var(--color-green-softer)",
		bold: "var(--color-green-bold)",
		darker: "var(--color-green-darker)",
	},
	yellow: {
		"50": "var(--color-yellow-50)",
		"100": "var(--color-yellow-100)",
		"200": "var(--color-yellow-200)",
		"300": "var(--color-yellow-300)",
		"400": "var(--color-yellow-400)",
		"500": "var(--color-yellow-500)",
		"600": "var(--color-yellow-600)",
		"700": "var(--color-yellow-700)",
		"800": "var(--color-yellow-800)",
		"900": "var(--color-yellow-900)",
		DEFAULT: "var(--color-yellow-default)",
		dark: "var(--color-yellow-dark)",
		light: "var(--color-yellow-light)",
	},
	red: {
		"50": "var(--color-red-50)",
		"100": "var(--color-red-100)",
		"200": "var(--color-red-200)",
		"300": "var(--color-red-300)",
		"400": "var(--color-red-400)",
		"500": "var(--color-red-500)",
		"600": "var(--color-red-600)",
		"700": "var(--color-red-700)",
		"800": "var(--color-red-800)",
		"900": "var(--color-red-900)",
		DEFAULT: "var(--color-red-default)",
		dark: "var(--color-red-dark)",
		light: "var(--color-red-light)",
	},
	blue: {
		"50": "var(--color-blue-50)",
		"100": "var(--color-blue-100)",
		"200": "var(--color-blue-200)",
		"300": "var(--color-blue-300)",
		"400": "var(--color-blue-400)",
		"500": "var(--color-blue-500)",
		"600": "var(--color-blue-600)",
		"700": "var(--color-blue-700)",
		"800": "var(--color-blue-800)",
		"900": "var(--color-blue-900)",
		DEFAULT: "var(--color-blue-default)",
		dark: "var(--color-blue-dark)",
		light: "var(--color-blue-light)",
		lighter: "var(--color-blue-lighter)",
		softer: "var(--color-blue-softer)",
		medium: "var(--color-blue-medium)",
		bold: "var(--color-blue-bold)",
		darker: "var(--color-blue-darker)",
	},
	status: statusColors,
	gradients: gradientColors,
	opacity: opacityColors,
	overlay: overlayColors,
} as const;
